import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import OrganizationsTable from '../components/OrganizationsTable';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const OrganizationsSubscriptionPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Abonelik" />
      <div className="dashboard-main active">
        <div className="container-fluid">
          <OrganizationsTable status="subscription" />
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </MasterLayout>
  );
};

export default OrganizationsSubscriptionPage;

